"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowType = void 0;
var FlowType;
(function (FlowType) {
    FlowType["ACCOUNT_IN_FOCUS"] = "account-in-focus";
    FlowType["SERVICES"] = "services";
    FlowType["NOAUTH_ACCOUNT_IN_FOCUS"] = "noauth-account-in-focus";
    FlowType["NOAUTH_SERVICES"] = "noauth-services";
    FlowType["LOGIN_SIMPLE"] = "login-simple";
})(FlowType = exports.FlowType || (exports.FlowType = {}));
//# sourceMappingURL=LoginConsoleProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/LoginConsole/LoginConsoleProps.js
// module id = 260
// module chunks = 8